/* ORAVIE — cart drawer. No dependencies, no framework.
   Progressive enhancement only: every add-to-cart form still works as a plain
   POST if this file fails to load or JavaScript is off, and the header cart
   icon is still a real link to /cart. Nothing here invents scarcity, timers
   or activity messages. */
(function () {
  'use strict';

  var CFG = window.ORAVIE_CART || {};
  var root = null;
  var body = null;
  var footer = null;
  var lastFocus = null;
  var busy = false;

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* Money. cart.js returns integer cents; the shop's money format string is
     handed over by Liquid so the drawer prints exactly what the rest of the
     store prints. */
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    function group(v, dec) {
      var s = Math.abs(v).toFixed(dec);
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return (v < 0 ? '-' : '') + parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, key) {
      switch (key) {
        case 'amount': return group(n, 2);
        case 'amount_no_decimals': return group(n, 0);
        case 'amount_with_comma_separator': return group(n, 2).replace(/,/g, ' ').replace('.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(n, 0).replace(/,/g, ' ');
        default: return group(n, 2);
      }
    });
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function setBusy(v) {
    busy = v;
    if (root) root.setAttribute('data-busy', v ? 'true' : 'false');
  }

  /* ---------- open / close ---------- */
  function open() {
    if (!root) return;
    lastFocus = document.activeElement;
    root.setAttribute('data-open', 'true');
    document.body.setAttribute('data-cart-lock', 'true');
    var x = $('.cdr__x', root);
    if (x) x.focus();
  }

  function close() {
    if (!root) return;
    root.setAttribute('data-open', 'false');
    document.body.removeAttribute('data-cart-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- rendering ---------- */
  function bubble(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.hidden = count < 1;
    });
    $$('[data-cart-open]').forEach(function (el) {
      el.setAttribute('aria-label', 'Cart, ' + count + (count === 1 ? ' item' : ' items'));
    });
  }

  function lineHTML(item, index) {
    var img = item.image
      ? '<img src="' + esc(item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2')) + '" alt="" width="64" height="64" loading="lazy">'
      : '<span></span>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<p class="cdr__lv">' + esc(item.variant_title) + '</p>' : '';
    return '' +
      '<div class="cdr__line" data-line="' + (index + 1) + '">' +
        img +
        '<div>' +
          '<p class="cdr__ln">' + esc(item.product_title) + '</p>' +
          variant +
          '<div class="cdr__lb">' +
            '<span class="cdr__q">' +
              '<button type="button" data-step="-1" aria-label="Decrease quantity">&minus;</button>' +
              '<span aria-live="polite">' + item.quantity + '</span>' +
              '<button type="button" data-step="1" aria-label="Increase quantity">+</button>' +
            '</span>' +
            '<span class="cdr__lp">' + money(item.final_line_price) + '</span>' +
          '</div>' +
          '<button type="button" class="cdr__rm" data-remove>Remove</button>' +
        '</div>' +
      '</div>';
  }

  /* The drawer offer is an UPGRADE, not an add-on: it swaps the bundle in the
     cart for the next size up at that bundle's real Shopify price, so the
     shopper ends up with the cheaper per-box figure rather than two lines that
     cost more together than the larger bundle does on its own. Liquid supplies
     the rules; nothing is calculated or claimed here. It shows only when a
     matching line is in the cart, and only once. */
  function upgradeFor(cart) {
    var rules = CFG.upgrades || [];
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      var has = cart.items.some(function (it) { return String(it.variant_id) === String(r.from); });
      var already = cart.items.some(function (it) { return String(it.variant_id) === String(r.to); });
      if (has && !already) return r;
    }
    return null;
  }

  function upsellHTML(cart) {
    var r = upgradeFor(cart);
    if (!r) return '';
    return '' +
      '<div class="cdr__up">' +
        '<h3>' + esc(CFG.upsellTitle || 'Complete your routine') + '</h3>' +
        '<p>' + esc(r.text || '') + '</p>' +
        '<button type="button" class="cdr__upb" data-upgrade="' + esc(r.from) + '|' + esc(r.to) + '">' +
          esc(r.cta || 'Add & save') +
        '</button>' +
      '</div>';
  }

  function upgrade(fromId, toId) {
    if (busy) return;
    setBusy(true);
    var updates = {};
    updates[fromId] = 0;
    updates[toId] = 1;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); setBusy(false); })
      .catch(function () { setBusy(false); window.location.href = '/cart'; });
  }

  function render(cart) {
    if (!body || !footer) return;
    bubble(cart.item_count);

    if (!cart.item_count) {
      body.innerHTML =
        '<div class="cdr__empty">' +
          '<p>Your cart is empty.</p>' +
          '<a class="obun__b" href="' + esc(CFG.productUrl || '/') + '">' + esc(CFG.emptyCta || 'Shop GumRevive') + '</a>' +
        '</div>';
      footer.hidden = true;
      return;
    }

    body.innerHTML = cart.items.map(lineHTML).join('') + upsellHTML(cart);
    footer.hidden = false;
    var total = $('[data-cart-total]', footer);
    if (total) total.textContent = money(cart.total_price);
  }

  function fetchCart() {
    return fetch(CFG.cartJsUrl || '/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refresh() {
    setBusy(true);
    return fetchCart().then(function (c) { render(c); setBusy(false); return c; })
      .catch(function () { setBusy(false); });
  }

  function change(line, quantity) {
    if (busy) return;
    setBusy(true);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (c) { render(c); setBusy(false); })
      .catch(function () { setBusy(false); window.location.href = '/cart'; });
  }

  function add(id, qty) {
    setBusy(true);
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(qty) || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return refresh();
      })
      .then(function () { setBusy(false); open(); })
      .catch(function () { setBusy(false); window.location.href = '/cart'; });
  }

  /* ---------- wiring ---------- */
  function wire() {
    root = document.getElementById('cart-drawer');
    if (!root) return;
    body = $('.cdr__body', root);
    footer = $('.cdr__foot', root);

    $$('[data-cart-open]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        open();
        refresh();
      });
    });

    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-close]')) { close(); return; }

      var stepBtn = e.target.closest('[data-step]');
      if (stepBtn) {
        var wrapA = stepBtn.closest('[data-line]');
        if (!wrapA) return;
        var line = parseInt(wrapA.getAttribute('data-line'), 10);
        var cur = parseInt($('.cdr__q span', wrapA).textContent, 10) || 1;
        change(line, Math.max(0, cur + parseInt(stepBtn.getAttribute('data-step'), 10)));
        return;
      }

      var rm = e.target.closest('[data-remove]');
      if (rm) {
        var wrapB = rm.closest('[data-line]');
        if (wrapB) change(parseInt(wrapB.getAttribute('data-line'), 10), 0);
        return;
      }

      var up = e.target.closest('[data-upgrade]');
      if (up) {
        var pair = up.getAttribute('data-upgrade').split('|');
        if (pair.length === 2) upgrade(pair[0], pair[1]);
        return;
      }

      if (e.target.closest('[data-cart-checkout]')) {
        window.location.href = '/checkout';
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.getAttribute('data-open') === 'true') close();
    });

    /* Add-to-cart forms become drawer-openers. If anything at all goes wrong
       the browser falls back to the plain POST it was always going to do. */
    $$('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (!window.fetch) return;
        var idField = form.querySelector('[name="id"]');
        if (!idField || !idField.value) return;
        var qtyField = form.querySelector('[name="quantity"]');
        e.preventDefault();
        add(idField.value, qtyField ? qtyField.value : 1);
      });
    });

    /* Prime the count on first paint without opening anything. */
    fetchCart().then(function (c) { bubble(c.item_count); }).catch(function () {});
  }

  if (document.readyState !== 'loading') wire();
  else document.addEventListener('DOMContentLoaded', wire);
})();
